import { parseQueryString } from "@client/lib/api";

import "./magnific.less";

export enum MagnificType {
  None = "none",
  Gallery = "gallery",
  IFrame = "iframe",
  Image = "image",
  Inline = "inline"
}

export interface MagnificOptions {
  type: MagnificType;
}

export default (element: HTMLElement, options: MagnificOptions) => {
  if (!element) throw new Error("magnific: element is required");

  switch (options.type) {
    case MagnificType.None: {
      const $element = $(element);
      if ($element.data("magnificPopup")) {
        $element.off("click");
        $element.removeData("magnificPopup");
      }
      break;
    }
    case MagnificType.Gallery: {
      $(element).magnificPopup({
        delegate: "a",
        type: "image",
        image: {
          verticalFit: true
        },
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
          beforeOpen: function () {
            this.st.image.markup = this.st.image.markup.replace("mfp-figure", "mfp-figure mfp-with-anim");
            this.st.mainClass = "mfp-zoom-out";
          }
        }
      });
      break;
    }
    case MagnificType.IFrame: {
      $(element).magnificPopup({
        type: "iframe",
        iframe: {
          // markup: `<iframe class="mfp-iframe" frameborder="0" scrolling="no" allowtransparency="true" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>`,
          patterns: {
            youtube: {
              index: "youtube.com/",
              id: function (url) {
                const id = parseQueryString(url).v;
                if (id) return id;

                const m = url.match(/youtube\.com\/([^/?]+)/);
                if (!m || !m[1]) return null;
                return m[1];
              },
              src: "//www.youtube.com/embed/%id%?autoplay=1"
            },
            youtubeAlt: {
              index: "youtu.be/",
              id: function (url) {
                var m = url.match(/youtu\.be\/([^/?]+)/);
                if (!m || !m[1]) return null;
                return m[1];
              },
              src: "//www.youtube.com/embed/%id%?autoplay=1"
            },
            vimeo: {
              index: "vimeo.com/",
              id: function (url) {
                var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
                if (!m || !m[5]) return null;
                return m[5];
              },
              src: "//player.vimeo.com/video/%id%?autoplay=1"
            }
          }
        },
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
          beforeOpen: function () {
            this.st.image.markup = this.st.image.markup.replace("mfp-figure", "mfp-figure mfp-with-anim");
            this.st.mainClass = "mfp-zoom-out";
          }
        }
      });
      break;
    }
    case MagnificType.Image: {
      $(element).magnificPopup({
        type: "image",
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
          beforeOpen: function () {
            this.st.image.markup = this.st.image.markup.replace("mfp-figure", "mfp-figure mfp-with-anim");
            this.st.mainClass = "mfp-zoom-out";
          }
        }
      });
      break;
    }
    case MagnificType.Inline: {
      $(element).magnificPopup({
        type: "inline",
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
          beforeOpen: function () {
            this.st.image.markup = this.st.image.markup.replace("mfp-figure", "mfp-figure mfp-with-anim");
            this.st.mainClass = "mfp-zoom-out";
          }
        },
        closeBtnInside: false,
        fixedContentPos: true,
        overflowY: "scroll"
      });
    }
  }
};
